import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Stack, Text } from '@bingads-webui-react/fabric-control';

export const ErrorString = ({
  error,
}) => (
  <Fragment>
    <Text className="error-string" variant="small" block nowrap styles={{ root: { color: '#A80000' } }}>{error}</Text>
  </Fragment>
);

ErrorString.propTypes = {
  error: PropTypes.string,
};
ErrorString.defaultProps = {
  error: '',
};

export const Errors = ({
  errors,
}) => (
  <div className="errors">
    {errors && errors.map(error => ErrorString({ error }))}
  </div>
);

Errors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const SpanWithComponent = ({
  SpanText,
  Component,
}) => (
  <Fragment>
    <span>{SpanText}</span>
    <Component />
  </Fragment>
);

SpanWithComponent.propTypes = {
  Component: PropTypes.func.isRequired,
  SpanText: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
};

export const withVerticalAlignCenterSpan = Component => (
  props,
  defaultRender
) => (
  <Fragment>
    <Stack horizontal verticalAlign="center">
      <SpanWithComponent SpanText={defaultRender(props)} Component={Component} />
    </Stack>
  </Fragment>
);

const nameErrorCode = {
  RequiredField: 'RequiredField',
  ExceedLength: 'ExceedLength',
};

export const getNameErrorMsg = ({ code, i18n, maxLength }) => {
  switch (code) {
    case nameErrorCode.RequiredField:
      return i18n.getString(_TL_('Required field'));
    case nameErrorCode.ExceedLength:
      return i18n.getString(_TL_('Field should not exceed {{number}} characters'), { number: maxLength });
    default:
      return null;
  }
};

export const validateName = ({ name, maxLength }) => {
  let error = null;
  if (name == null || name === '') {
    error = nameErrorCode.RequiredField;
  } else if (name && name.length > maxLength) {
    error = nameErrorCode.ExceedLength;
  }
  return error;
};

export const checkShouldShowError = attribute => attribute.isInvalid || attribute.isDirty;
export const checkShouldShowErrors = attribute => (attribute.errors && attribute.errors.length > 0);
